import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({

    margin:{
        margin:"30px 24px 0px 24px"

    },
    homeBannerCard:{
        width:"100%",
    },
    "@media (max-width: 550px)":{
         homeBannerCard:{
            maxWidth: "550px",
        },
        homeBanner:{
            cursor: "pointer",
            width: "100%",
            display: "block",
            padding:"0px 12px"
        },
       
       }

}))

export default style;



